import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts";
import { getCommunityIconUrl } from "@/react/helpers/communityHelpers";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { useThemeContext } from "@circle-react/providers";
import type { ResourceSection } from "../shared/types";
import { triggerChiliPiperForPlusButton } from "./chiliPiperUtils";
import customAppIcon from "./custom-app.svg";
import { useCommunityEligibleForPlusLead } from "./useCommunityEligibleForPlusLead";

const localeRoot = "community_onboarding.new_checklist.circle_app_links";

export const useCustomAppSection = (): ResourceSection => {
  const isEligibleForPlusLead = useCommunityEligibleForPlusLead();
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const { isDarkAppearance } = useThemeContext();

  const iconURL = getCommunityIconUrl(currentCommunity, isDarkAppearance);

  const { trackEvent } = useEventsTracker();

  const handleOnClickAnalyticsEvent = () => {
    trackEvent("plus_banner.cta.clicked", {
      origin:
        currentCommunityMember && isEligibleForPlusLead
          ? "getting_started.checklist.book_demo.button"
          : "getting_started.checklist.link",
    });
  };

  const baseSection = {
    icon: iconURL || customAppIcon,
    title: t(`${localeRoot}.sections.custom_app.title`),
    description: t(`${localeRoot}.sections.custom_app.description`),
    iconAlt: t(`${localeRoot}.sections.custom_app.icon_alt`),
    onClick: handleOnClickAnalyticsEvent,
  };

  const linkSection = {
    ...baseSection,
    link: "https://circle.so/plus",
  };

  if (currentCommunityMember && isEligibleForPlusLead) {
    const { email, first_name, last_name } = currentCommunityMember;
    return {
      ...baseSection,
      button: {
        label: t(`${localeRoot}.sections.custom_app.button_label`),
        handleClick: () => {
          handleOnClickAnalyticsEvent();

          void triggerChiliPiperForPlusButton(email, first_name, last_name);
        },
      },
    };
  }

  return linkSection;
};
